import { createPromiseAction } from '@adobe/redux-saga-promise';

import * as actionTypes from './actionTypes';

export const sendNotification = createPromiseAction(actionTypes.SEND_NOTIFICATION);
